module.exports = __webpack_public_path__ + "static/media/login.a9a72820.mp4";